interface PaginationState {
  max: number;
  total: number;
  pageSize: number;
  pageCount: number;
  currentPage: number;
  hasNext: boolean;
}

export const EmptyPagination: PaginationState = {
  max: 0,
  total: 0,
  pageSize: 1,
  pageCount: 0,
  currentPage: 1,
  hasNext: false,
};

export default PaginationState;
